import axios from "axios";
import { config } from "../config";


export const handleForgotPassword = async (data) => {
    const { email} = data
    let fd = new FormData()
    fd.append('email', email)
   
    let res = await axios({
        method: "POST",
        data: fd,
        url: `${config.apiurl}forgot_password`,
        withCredentials: true,
    })
    return res
};
